import { target, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [target.static] = ['canvas', 'button', 'hiddenInput']

  async connectedCallback () {
    const scale = 3

    this.canvas.width = this.canvas.parentNode.clientWidth * scale
    this.canvas.height = this.canvas.parentNode.clientHeight * scale

    this.canvas.getContext('2d').scale(scale, scale)

    this.hasValue = false

    // Make canvas focusable
    this.canvas.setAttribute('tabindex', '0')

    // Handle typing
    this.canvas.addEventListener('focus', () => {
      this.canvas.classList.add('ring-2', 'ring-[#043f42]', 'ring-inset')
    })

    this.canvas.addEventListener('blur', () => {
      this.canvas.classList.remove('ring-2', 'ring-[#043f42]', 'ring-inset')
    })

    this.canvas.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace') {
        this.text = (this.text || '').slice(0, -1)
      } else if (e.key.length === 1 && /[a-zA-Z]/.test(e.key)) {
        if ((this.text || '').length < 5) {
          this.text = (this.text || '') + e.key.toUpperCase()
        }
      }
      this.renderText()
      this.updateButtonState()
    })

    // Click to focus
    this.canvas.addEventListener('click', () => {
      this.canvas.focus()
    })

    this.button.addEventListener('click', (e) => {
      e.preventDefault()
      if (!this.text || !this.text.trim()) return
      this.button.disabled = true
      this.submit()
    })
  }

  renderText () {
    const text = (this.text || '').toUpperCase()
    const ctx = this.canvas.getContext('2d')

    ctx.clearRect(0, 0, this.canvas.width / 3, this.canvas.height / 3)

    const placeholder = this.querySelector('[data-initials-placeholder]')
    const preview = this.querySelector('[data-initials-preview]')

    if (text) {
      if (placeholder) placeholder.classList.add('hidden')
      if (preview) preview.classList.add('hidden')

      const fontSize = Math.min(this.canvas.parentNode.clientHeight * 0.45, 40)
      ctx.font = `${fontSize}px 'Brush Script MT', 'Segoe Script', 'Arial', cursive`
      ctx.fillStyle = '#000000'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(text, this.canvas.parentNode.clientWidth / 2, this.canvas.parentNode.clientHeight / 2)
    } else {
      if (placeholder) placeholder.classList.remove('hidden')
    }
  }

  updateButtonState () {
    const hasText = this.text && this.text.trim().length > 0
    if (hasText) {
      this.button.classList.remove('opacity-50', 'cursor-not-allowed')
      this.button.classList.add('hover:bg-[#09696e]')
    } else {
      this.button.classList.add('opacity-50', 'cursor-not-allowed')
      this.button.classList.remove('hover:bg-[#09696e]')
    }
  }

  async submit () {
    const blob = await new Promise((resolve) => {
      this.canvas.toBlob((b) => resolve(b), 'image/png')
    })

    const file = new File([blob], 'initials.png', { type: 'image/png' })

    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.hiddenInput.files = dataTransfer.files

    this.closest('form').requestSubmit()
  }
})
